import type { OneOrMany } from "@suse-o11y/one-or-many";
import type { ReactNode } from "react";

/**
 * React.Children.map does not pick up functions as children,
 * so the workaround is to map over children manually.
 */
export function mapChildren<TChild, TResult = ReactNode>(
	children: OneOrMany<TChild>,
	fn: (child: TChild, index: number) => TResult,
): Array<TResult> {
	return [children].flat().map(fn);
}
